<template>
	<div class="main">
		<div class="mainIn">
			<el-tabs v-model="tabActiveName" @tab-click="tabClick">
				<el-tab-pane label="外部参会人员" name="outer">
				</el-tab-pane>

				<el-tab-pane label="内部参会人员" name="inner">
				</el-tab-pane>
			</el-tabs>

			<el-row class="alignLeft search" >
				<el-col :span='24' v-if="tabActiveName == 'inner'">
					<el-col :span="5">
						<el-input v-model="keyword" clearable placeholder="请输入关键字"></el-input>
					</el-col>
					<el-col :span='18' :offset="1">
						<el-button class="width80" type="primary" @click="inputSearch">搜索</el-button>
					</el-col>
				</el-col>
				<el-col :span='24' v-if="tabActiveName == 'outer'">
					<el-col :span="5">
						<el-input v-model="keyword" clearable placeholder="请输入关键字"></el-input>
					</el-col>
					<el-col :span="10" :offset="1" @click.native="QueryHospitalConfig({type:'web'})">
						<popover-table
							v-model="hospitalName"
							:placeholder="'请选择医院'"
							selectField="name"
							:tableTitle="hospitalTitle"
							:tableData="hospitalData"
							:total="hospitalTotal"
							:pageSize="5"
							:pageIndex="pageIndex"
							:inputSearch="QueryHospitalConfig">
						</popover-table>
					</el-col>
					<el-col :offset="1" :span="6">
						<el-button @click.native="resetSearch()">重置</el-button>
						<el-button class="width80" type="primary" @click="inputSearch">搜索</el-button>
					</el-col>
				</el-col>
			</el-row>

			<el-table size="small" @row-click="rowClick" ref="multipleTable" :row-key="getRowKeys" border :data="tableData" tooltip-effect="dark" style="width: 100%" height='300' @select="checkboxSelect" @selection-change="handleSelectionChange">
				<el-table-column type="selection" :selectable="selectable"></el-table-column>
				<el-table-column show-overflow-tooltip v-for="(item,index) in tableTitle" :prop="item.key" :label="item.val" :key="index"></el-table-column>
			</el-table>

            <el-pagination class="paging" small :pager-count="5" background @current-change="handleCurrentChange" :current-page.sync="pageIndex" :page-size="pageSize" layout="prev, pager, next, jumper" :total="total"></el-pagination>

			<div class="selected">
				<div class="colorActive alignLeft">已选择：</div>
				<div class="alignLeft">
					<!-- <span class="selector color6" v-for="(item,index) in selectData" :key="index">{{ item.name || item.cName }}</span> -->
                    <el-tag
                        style="margin: 0 4px 4px 0;"
                        v-for="(item, index) in selectData"
                        :key="index"
                        closable
                        @close="tagClose(item, index)">
                        {{ item.name || item.cName }}
                    </el-tag>
				</div>
			</div>
			<el-row class="footer">
				<el-button class="width100 falseBtn" @click.native="doSave(false)">取消</el-button>
				<el-button class="width100 sureBtn" :loading="btnLoading" @click.native="doSave(true)">确定</el-button>
			</el-row>
		</div>
	</div>
</template>

<script>
	import attenderEditor from '@scripts/components/attenderEditor.js';
	import hospitalSelector from '@scripts/components/hospitalSelector.js';
	import popoverTable from './popoverTable';
	export default {
		mixins: [attenderEditor, hospitalSelector],
		components: {
			popoverTable
		},
		data() {
			return {
				tabActiveName: 'outer',
				tableTitle: [],
				tableData: [],
				outAttendListTitle: [{
					key: 'name',
					val: '参会人'
				}, {
					key: 'from',
					val: '来源'
				}, {
					key: 'hospital',
					val: '医院'
				}, {
					key: 'section',
					val: '科室'
				}, {
					key: 'email',
					val: '邮箱'
				}],
				innerAttendListTitle: [{
					key: 'cName',
					val: '参会人'
				}, {
					key: 'from',
					val: '来源'
				}, {
					key: 'identifyCode',
					val: '员工号'
				}, {
					key: 'dept',
					val: '部门'
				}, {
					key: 'email',
					val: '邮箱'
				}],
				hospitalTitle: [{
					titleId: 'name',
					titleText: '医院名称'
				}, {
					titleId: 'level',
					titleText: '医院等级'
				}, {
					titleId: 'city',
					titleText: '所在城市'
				}],
				hospitalData: [],
				selectData: [],
				doType: true,
				// 获取row的key值
				getRowKeys(row) {
					return row.orderid;
				},
				modelData: {},
				btnLoading: false,
			}
		},
		async created() {
			this.tableTitle = this.outAttendListTitle; // 默认：外部参会人员
			this.getOutList(); //获取外部参会人、签到
			this.getAttender();
		},
		methods: {
			//获取已经添加的参会人，从A1传过来的
			getAttender() {
				this.modelData = this.iStorage.get('model');
//				console.log(this.modelData.taskList);
			},
			// 获取外部参会人员
			async getOutList() {
				let outTempList = await this.HcpInfoPagingByMarker('web');
        outTempList.rows.map(ele => {
            ele.inviteEmail = ele.email
            ele.invitePhone = ele.phoneNumber
        });
				this.tableData = outTempList.rows;
				this.total = outTempList.total;
				this.reloadSelect();
			},
			// 获取内部参会人员
			async getInnerList() {
				let innerTempList = await this.EmployeePagingByMarker('web');
        innerTempList.rows.map(ele => {
            ele.inviteEmail = ele.email
            ele.invitePhone = ele.mobile
        });
        this.tableData = innerTempList.rows;
				this.total = innerTempList.total;
				this.reloadSelect();
			},
			//点击行选中
			rowClick(row,index){
                console.log("rowClick:", row)
				if(!row.isChecked){
					this.$refs.multipleTable.toggleRowSelection(row);
                }
                this.selectDataFilter(row)
            },
            // 点击复选框
            checkboxSelect(selection, row) {
                console.log("checkboxSelect:", row)
                console.log(this.selectData)
                this.selectDataFilter(row)
            },
            selectDataFilter(rowItem) {
                if(rowItem.isChecked) return
                let existIndex = null

                rowItem.attenderType =  this.tabActiveName == "outer" ? 1 : 2;
                this.selectData.map((item, index) => {
                    if((rowItem.hcpId && item.hcpId == rowItem.hcpId) || (rowItem.userId && item.userId == rowItem.userId)) {
                        existIndex = index
                    }
                })
                console.log(existIndex)
                if(existIndex != null) {
                    this.selectData.splice(existIndex, 1)
                }else {
                    this.selectData.push(rowItem)
                }
            },
            //
            tagClose(item, itemIndex) {
                console.log(itemIndex)
                this.selectData.splice(itemIndex, 1)
				this.$nextTick(()=>{
					this.tableData.map((ele, index)=>{
                        if((item.hcpId && ele.hcpId == item.hcpId) || (item.userId && ele.userId == item.userId)) {
                            this.$refs.multipleTable.toggleRowSelection(ele);
                        }
                    })
				})
            },
			//已经选择的数据不能在这里修改，否则逻辑都错乱了！！！
			selectable(row, index) {
				return !row.isChecked
			},
			//重现已选择的数据
			reloadSelect() {
				this.$nextTick(()=>{
					this.tableData.map((ele)=>{
						if(ele.isChecked){
							this.$refs.multipleTable.toggleRowSelection(ele);
						}else {
                            this.selectData.map(item => {
                                if((ele.hcpId && ele.hcpId == item.hcpId) || (ele.userId && ele.userId == item.userId)) {
                                    this.$refs.multipleTable.toggleRowSelection(ele);
                                }
                            })
                        }
                    })
				})
			},
			// 选中table中的数据（包括一个，以及全部）全选功能与跨标签累加功能冲突
			handleSelectionChange(rows) {
				//过滤未添加的人员，避免重复添加人员
				// this.selectData = rows.filter((ele)=>{
        //   ele.attenderType =  this.tabActiveName == "outer" ? 1 : 2;
				// 	return !ele.isChecked
				// });
      },
			// 切换分页
			handleCurrentChange(val) {
				this.pageIndex = val;
				if(this.tabActiveName == 'outer') {
					this.getOutList();
				}
				if(this.tabActiveName == 'inner') {
					this.getInnerList();
				}
			},
			// 切换tab
			tabClick(tab, event) {
				// 每次切换tab都要初始化分页,输入查询内容
				this.pageIndex = 1;
				this.keyword = '';
				if(tab.name == 'outer') {
					this.tableTitle = this.outAttendListTitle;
					this.getOutList();
				}
				if(tab.name == 'inner') {
					this.tableTitle = this.innerAttendListTitle;
					this.getInnerList();
				}
				console.log(this.tableTitle);
			},
			//重置搜索
			resetSearch(){
				this.hospitalName = '';
				this.keyword = '';
			},
			// 输入查询
			inputSearch() {
				this.pageIndex = 1;
				if(this.tabActiveName == 'outer') {
					this.getOutList();
				}
				if(this.tabActiveName == 'inner') {
					this.getInnerList();
				}
			},
			// 保存，取消操作
			async doSave(type) {
				this.doType = type;
				if(type) {
					this.btnLoading = true
					let response = await this.AttenderSave(this.selectData, 'web')
					if(response && response.success){
						console.log(response)
						this.$message({
							message: '保存成功',
							type: 'success'
						})
						this.closeIframe();
					}
					this.btnLoading = false
				} else {
					this.closeIframe();
          this.btnLoading = false
					return;
				}
			},
			// 关闭iframe-dialog回调
			closeIframe() {
				let data = {
					from: "simulator",
					to: "attenderEditor",
					type: this.doType // true关闭后，调用者会执行传递的handler，false关闭后，则不执行。
				};
				window.parent.postMessage(data, "*");
			}
		}
	}
</script>

<style>
	.el-table th>.cell {
		text-align: center;
	}

	.el-table th {
		background: #dedede;
	}
</style>

<style scoped>
	@import '../assets/css/public.css';
	.main {
		width: 840px;
		margin: 0 auto;
		padding: 0 0 50px;
		color: #666666;
		font-size: 16px;
	}

	.search {
		margin: 0 auto 10px;
	}

	.mainIn {
		padding: 0 50px;
	}

	.item {
		padding: 10px 0;
	}

	.footer {
		margin: 20px 0 0 0;
	}

	.paging {
		margin: 10px 0;
        text-align: right;
	}

	.selected {
		padding: 10px 0;
		border-top: 1px dashed #cccccc;
		border-bottom: 1px dashed #cccccc;
	}

	.selector {
		display: inline-block;
		margin: 10px 20px 0 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/attenderEditor.vue